import { Controller } from "@hotwired/stimulus"
import * as mobiscroll from "@mobiscroll/javascript"
import moment from "moment"

export default class extends Controller {
  static values = {
    locale: String
  }

// 'display' is meant to be a text field. This field opens the picker when clicked.
// 'value' is meant to be a hidden field. This field receives the selected date in ISO8601 format.
  static targets = [
    "display",
    "value",
  ]

  connect() {
    this.mobiscroll = mobiscroll.datepicker(this.displayTarget, {
      // Style
      theme: "material",
      themeVariant: "light",
      controls: ["calendar"],
      select: "range",
      responsive: {
        xsmall: {
          // min-width: 0px
          display: "bottom",
        },
        small: {
          // min-width: 576px
          display: "bottom",
        },
        medium: {
          // min-width: 768px
          display: "anchored",
        },
      },
      anchor: this.displayTarget,
      endInput: this.displayTarget,
      showInput: false,
      showRangeLabels: false,
      colors: [{
        start: moment(this.displayTarget.max, "YYYY-MM-DD", true).add(1, "day"),
        end: moment(this.displayTarget.max, "YYYY-MM-DD", true).add(30, "days"),
        cellCssClass: "tw:*:*:line-through",
      }],

      // // Constraints
      min: this.displayTarget.min,
      max: this.displayTarget.max,
      minRange: 2,
      returnFormat: "iso8601",

      // // Localization
      locale: mobiscroll.locale[this.localeValue],

      onInit: (_event, instance) => {
        instance.setVal([this.displayTarget.min, this.valueTarget.value])
        instance.setActiveDate("end")
      },
      onChange: (event, instance) => {
        let start
        let end
        [start, end] = event.value || []

        // make sure the end date is always the one in focus
        instance.setActiveDate("end")

        if(end) {
          this.valueTarget.value = end
          instance.close()
        }
      },
      // On mobile, there's a "temporary" state change before pressing "cancel" or "set"
      onTempChange: (event, instance) => {
        let start
        let end
        [start, end] = event.value || []

        // make sure the end date is always the one in focus
        instance.setActiveDate("end")

        if(end) {
          this.valueTarget.value = end
          instance.setVal([this.displayTarget.min, this.valueTarget.value])
          instance.close()
        }
      }
    })
  }
}
